module.exports = __webpack_public_path__ + "static/gift.7032a8e8.jpg";


//////////////////
// WEBPACK FOOTER
// /tmp/build_2cb81483/src/assets/images/home/plans/gift.jpg
// module id = 1342
// module chunks = 4